import Helper from "@/services/Helper"

export default class Default {
    filterParams() {
        return {
            params: {
                search: "",
                search_full_match: true,
                date: null,
                users: [],
                statuses: {
                    published: true,
                    scheduled: true,
                    removed: false,
                    draft: false,
                },
                shops: [],
                categories: [],
                type_visibility: null,
                type_ids: [],
                is_moderate: null,
                type_id: [],
                promocode: "",
            },
            saveForm: true,
            enable: true,
        }
    }

    prepareQuery(q) {
        let query = Helper.clone(q)

        return query
    }
}
